import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Globe, ChevronDown, Check } from "lucide-react";
import { useI18n } from "../context/I18nContext";

const LANGS = [["en", "EN", "English"], ["id", "ID", "Bahasa Indonesia"], ["pt", "PT-BR", "Português (Brasil)"]];

export const LanguageSwitcher = ({ className = "", up = false }) => {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState(null);
  const ref = useRef(null);
  const menuRef = useRef(null);
  const toggle = () => {
    const r = ref.current?.getBoundingClientRect();
    if (r) setPos(up ? { right: window.innerWidth - r.right, bottom: window.innerHeight - r.top + 6 } : { right: window.innerWidth - r.right, top: r.bottom + 6 });
    setOpen((v) => !v);
  };
  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target) && !menuRef.current?.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);
  const cur = LANGS.find(([l]) => l === lang) || LANGS[0];
  return (
    <div ref={ref} className={`relative inline-flex ${className}`} data-testid="language-switcher" data-no-i18n>
      <button
        data-testid="lang-toggle"
        onClick={toggle}
        className="inline-flex items-center gap-1.5 rounded-lg border border-white/10 bg-[#161820] hover:border-teal-500/50 px-2.5 py-1.5 text-[12px] font-bold text-white transition-colors"
      >
        <Globe className="h-3.5 w-3.5 text-teal-500" />
        {cur[1]}
        <ChevronDown className={`h-3 w-3 text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && createPortal(
        <div ref={menuRef} data-testid="lang-menu" style={pos || undefined} className="fixed z-[300] min-w-[190px] rounded-xl border border-white/10 bg-[#161820] p-1 shadow-2xl shadow-black/60">
          {LANGS.map(([l, short, name]) => (
            <button
              key={l}
              data-testid={`lang-${l}`}
              onClick={() => { setLang(l); setOpen(false); }}
              className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-xs transition-colors ${lang === l ? "bg-cyan-500/15 text-white" : "text-slate-300 hover:bg-white/5 hover:text-white"}`}
            >
              <span className="w-10 font-bold text-teal-500">{short}</span>
              <span className="flex-1">{name}</span>
              {lang === l && <Check className="h-3.5 w-3.5 text-cyan-400" />}
            </button>
          ))}
        </div>,
        document.body
      )}
    </div>
  );
};

export default LanguageSwitcher;
